const linkResolver = (doc) => {
  const uid = doc.uid === "homepage" && doc.type === 'custom_page' ? "" : doc.uid ? doc.uid.replaceAll("...", "/") : ""
  const hideInProduction = doc.data ? doc.data.hidden_in_production : false

  switch (doc.type) {
    case 'custom_page':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${uid}`
    case 'article':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getArticlesPath(doc.lang)}/${uid}`
    case 'podcast':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getPodcastsPath(doc.lang)}/${uid}`
    case 'whitepaper':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getWhitepapersPath(doc.lang)}/${uid}`
    case 'press_release':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getPressReleasePath(doc.lang)}/${uid}`
    case 'press_review':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getPressReviewPath(doc.lang)}/${uid}`
    case 'video':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getVideosPath(doc.lang)}/${uid}`
    case 'webinar':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getWebinarsPath(doc.lang)}/${uid}`
    case 'job_position':
      return `${hideInProduction ? '/hide' : ''}/${doc.lang}/${getJobPositionPath(doc.lang)}/${uid}`
    case 'faq_category':
      return `/${doc.lang}/${getSupportPath(doc.lang)}/${uid}`
    case 'faq_v2':
      if (doc.data && doc.data.category && doc.data.category.uid) {
        return `/${doc.lang}/${getSupportPath(doc.lang)}/${doc.data.category.uid}/${uid}`
      } else {
        // console.log(`/${doc.lang}/${getSupportPath(doc.lang)}/${uid}`)
        return `/${doc.lang}/${getSupportPath(doc.lang)}/${uid}`
      }
    default:
      return uid
  }
}

function getArticlesPath(folder) {
  switch (folder) {
    case 'it-it': return 'insight/blog'
    case 'en-gb': return 'insights/blog'
    case 'es-es': return 'recursos/blog'
    case 'fr-fr': return 'ressources/blog'
    default: return 'insights'
  }
}
function getPodcastsPath(folder) {
  switch (folder) {
    case 'it-it': return 'insight/podcast'
    case 'en-gb': return 'insights/podcast'
    default: return 'insights'
  }
}
function getWhitepapersPath(folder) {
  switch (folder) {
    case 'it-it': return 'insight/whitepaper'
    case 'en-gb': return 'insights/whitepaper'
    case 'es-es': return 'recursos/libros-blancos'
    case 'fr-fr': return 'ressources/livres-blancs'
    default: return 'insights'
  }
}
function getVideosPath(folder) {
  switch (folder) {
    case 'it-it': return 'insight/video'
    case 'en-gb': return 'insights/video'
    default: return 'insights'
  }
}
function getWebinarsPath(folder) {
  switch (folder) {
    case 'it-it': return 'insight/webinar'
    case 'en-gb': return 'insights/webinar'
    default: return 'insights'
  }
}
function getPressReleasePath(folder) {
  switch (folder) {
    case 'it-it': return 'comunicati-stampa'
    case 'en-gb': return 'press-releases'
    case 'es-es': return 'comunicados-de-prensa'
    case 'fr-fr': return 'communiques-de-presse'
    default: return 'press-releases'
  }
}
function getPressReviewPath(folder) {
  switch (folder) {
    case 'it-it': return 'rassegne-stampa'
    case 'en-gb': return 'press-reviews'
    case 'es-es': return 'resena-de-prensa'
    case 'fr-fr': return 'revue-de-presse'
    default: return 'press-reviews'
  }
}
function getJobPositionPath(folder) {
  switch (folder) {
    case 'it-it': return 'fabrick-people/unisciti-al-team'
    case 'en-gb': return 'fabrick-people/join-us'
    case 'es-es': return 'fabrick-people/unete-al-equipo'
    case 'fr-fr': return 'fabrick-people/rejoignez-lequipe'
    default: return 'fabrick-people/join-us'
  }
}

function getSupportPath(folder) {
  switch (folder) {
    case 'it-it': return 'assistenza'
    case 'en-gb': return 'support'
    case 'es-es': return 'asistencia'
    case 'fr-fr': return 'assistance'
    default: return 'support'
  }
}

module.exports = {
  linkResolver,
  getSupportPath,
  getArticlesPath,
  getWhitepapersPath,
}